import { prefixObjectValues } from '../../utils';

const form = {
  formDialog: 'dialog',
  form: 'form',
  institutionNameSelect: 'institutionName',
  institutionAddressLine1Input: 'institutionAddressLine1',
  institutionAddressLine2Input: 'institutionAddressLine2',
  institutionCityInput: 'institutionCity',
  institutionStateSelect: 'institutionState',
  institutionCountrySelect: 'institutionCountry',
  institutionPostalCodeInput: 'institutionPostalCode',
  startDateInput: 'startDate',
  endDateInput: 'endDate',
  graduationCheck: 'gradCheck',
  graduationDateInput: 'graduationDate',
  degreeSelect: 'degreeSelect',
  explanation: 'explainTextArea',
  submitBtn: 'btn-submit',
  closeBtn: 'btn-close',
};

export default prefixObjectValues(form, 'academic-education-form');
